import { Spin } from 'antd';
import { ConfigProvider } from 'antd';

const Loading = () => (
    <div className="loading-indicator">
          <ConfigProvider
            theme={{
                token: {
                    colorPrimary: '#C19372',
                },
            }}
            >
            <Spin/>
        </ConfigProvider>
    </div>
);

export default Loading;
